import { render } from "./PDFCartaPropostaFinalizado.vue?vue&type=template&id=c6120300&scoped=true"
import script from "./PDFCartaPropostaFinalizado.vue?vue&type=script&lang=js"
export * from "./PDFCartaPropostaFinalizado.vue?vue&type=script&lang=js"

import "./PDFCartaPropostaFinalizado.vue?vue&type=style&index=0&id=c6120300&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6120300"]])

export default __exports__